import React from "react";
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {SimpleMessageDialogBox} from "./boxes/simple-message-dialog.box";
import {
    IModalDialogHandler,
    ISimpleTextModalButtonOptions
} from "../../../../services/dialog/dialog.service.interface";
import {SimpleMessageDialogContentBox} from "./boxes/simple-message-dialog-content.box";
import {SimpleMessageDialogButtonsContainerBox} from "./boxes/simple-message-dialog-buttons-container.box";
import {observer} from "mobx-react";
import {SimpleMessageButtonComponent} from "./simple-message-dialog-button.component";
import {CyClass} from "../../../../../common/cy-classes";
import {SimpleMessageDialogIconContainerBox} from "./boxes/simple-message-dialog-icon-container.box";
import {Check} from "@sparkware/app-utils";
import {Image} from "../../../raw-components/image/image";
import {ISvgIconProps} from "../../../../basic-ui-components/icon/svg-icon/svg.icon";

interface SimpleMessageDialogComponentProps {
    text: string;
    /** @deprecated Do not send an icon as a string url or as react element. Use an svg icon in the iconSvg prop */
    icon?: string | React.ReactNode;
    iconSvg?: React.ComponentType<ISvgIconProps>;
    buttons: ISimpleTextModalButtonOptions[];
    dialogHandler: IModalDialogHandler;
}

@observer
export class SimpleMessageDialogComponent extends OrbitComponent<SimpleMessageDialogComponentProps> {

    private _renderIcon() {
        if(!this.props.icon) {
            return null;
        }

        if(Check.isString(this.props.icon)) {
            return <SimpleMessageDialogIconContainerBox>
                <Image src={this.props.icon}/>
            </SimpleMessageDialogIconContainerBox>;
        }

        return <SimpleMessageDialogIconContainerBox>
            {this.props.icon}
        </SimpleMessageDialogIconContainerBox>;
    }
    render() {
        return (
            <SimpleMessageDialogBox>
                {this._renderIcon()}
                <SimpleMessageDialogContentBox>
                    {this.props.text}
                </SimpleMessageDialogContentBox>
                <SimpleMessageDialogButtonsContainerBox className={CyClass('cy-modal-dialog-buttons-area')}>
                    {this.props.buttons.map(button => (<SimpleMessageButtonComponent key={button.text}
                                                                                     buttonOptions={button}
                                                                                     numberOfButtons={this.props.buttons.length}
                                                                                     dialogHandler={this.props.dialogHandler} />))}
                </SimpleMessageDialogButtonsContainerBox>
            </SimpleMessageDialogBox>
        );
    }
}